import styled from "@emotion/styled";
import { FormControlLabel, RadioGroup, typographyClasses, radioClasses } from "@mui/material";

export const ButtonGroup = styled(RadioGroup)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.system[200]}`,
  boxShadow: theme.shadows[1],
  overflow: "hidden",
  width: "fit-content"
}));

export const ButtonOption = styled(FormControlLabel)(({ checked, disabled, theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "44px",
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 2),
  margin: 0,
  cursor: disabled ? "default" : "pointer",
  backgroundColor: checked ? theme.palette.grey[50] : theme.palette.system[0],
  "&:not(:last-child)": {
    borderRight: `1px solid ${theme.palette.system[300]}`
  },
  ...(!disabled && {
    "&:hover, &:active": {
      backgroundColor: checked ? theme.palette.grey[50] : theme.palette.system[50],
    },
    [`&:hover > .${radioClasses.root}`]: {
      backgroundColor: theme.palette.system[100],
    },
    [`&:active > .${radioClasses.root}`]: {
      backgroundColor: theme.palette.tertiary[400],
    }
  }),
  [`& .${radioClasses.root}`]: {
    width: "20px",
    height: "20px",
    transition: theme.transitions.create(["background-color"], { duration: 100 })
  },
  [`& .${typographyClasses.root}`]: {
    ...theme.typography.body1,
    color: disabled ? theme.palette.text[600] : theme.palette.text[800]
  },
  ...(disabled && {
    "& .MuiSvgIcon-root": {
      color: theme.palette.grey[500]
    }
  })
}));

